export default "__VITE_ASSET__0xA4MY5w__"